import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.CompoundingPeriodEnumSortEnum>
) {
  const {
    pagination: { page, perPage },
    sort: { field, order },
  } = params;

  const {
    compoundingPeriodEnumList: { items: data, total },
  } = await sdk.getListCompoundingPeriodEnum({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage,
    },
    sort: [{ field, order }],
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { compoundingPeriodEnum: data } = await sdk.getOneCompoundingPeriodEnum(
    {
      id,
    }
  );
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(Number);

  const { compoundingPeriodEnumMany: data } =
    await sdk.getManyCompoundingPeriodEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const compoundingPeriodEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
});
